//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getRoom} from '../../../api/room'
import {getOwnersByRoomId, signSuccess} from '../../../api/newOwner'
import {getAllAssociate} from '../../../api/file'
import {updateMember} from '../../../api/member'
import {formatDate} from '../../../lib/date';
import moment from "moment";
import nations from "../../../assets/js/nations";
import areaList from "../../../assets/js/Area";
import DetailHousehold from "./detail-household";
import DetailContacts from "./detail-contacts";
import DetailCars from "./detail-cars";
import DetailKey from "./detail-key";
import util from "../../../lib/util";
import ImageUploader from "../../../components/ImageUploader";

export default {
  name: "detail",
  components: {DetailKey, DetailCars, DetailContacts, DetailHousehold, ImageUploader},
  data() {
    return {
      leftIco: require('@/assets/img/ico-building.png'),
      nations,
      roomInfo: {},
      memberInfo: {},
      saving: false,
      show: false,
      roomId: 0,
      memberList: [],
      selectedMember: {
        identityImage: {}
      },
      genderPopup: false,
      birthdayPopup: false,
      minDate: new Date(1920, 0, 1),
      currentDate: new Date(),
      nationPopup: false,
      educationPopup: false,
      educationColumns: ['小学', '初中', '高中', '技工学校', '中专', '大学专科和专科学校', '大学', '研究生'],
      nativePlacePopup: false,
      areaList,
      registeredResidencePopup: false,
      downloadUrl: util.ApiUrl + 'DocumentTransfer/ExportDeliveryDataPdf?roomId=',
      alreadySignPDFUrl: util.ApiUrl + 'DocumentTransfer/ExportAlreadySignPDF?roomId=',
      showSignPopup: false,
      options: {
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 1, //下笔的宽度 [Number] 可选
        lineCap: "round", //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: "round", //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: 330, //canvas宽高 [Number] 可选
        canvasHeight: 150, //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        bgColor: "#fcc", //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: "#ff787f", //网格颜色  [String] 可选
        writeWidth: 3, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 15, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: "#101010", // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: "png" //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
      isTrusteeship: true
    }
  },
  computed: {
    deliveryDataRecord() {
      return this.$store.state.newOwner.deliveryDataRecord;
    }
  },
  methods: {
    getRoom() {
      getRoom(this.roomId).then(res => {
        this.roomInfo = {}
        this.roomInfo = res.data.result
      })
    },
    getOwnersByRoomId() {
      getOwnersByRoomId(this.roomId).then(res => {
        this.memberList = []
        this.memberList.push(...res.data.result)
      })
    },
    async getMyMember() {
      this.$toast.loading({
        duration: 0,
        message: ''
      });
      await this.$store.dispatch({
        type: 'member/getMyMember'
      }).then(() => {
        this.memberInfo = this.$store.state.member.memberInfo;
      }).finally(() => {
        this.$toast.clear();
      });
    },

    onSaveMember() {
      // console.log(this.selectedMember)
      this.saving = true
      updateMember(this.selectedMember).then(res => {
        this.$toast.success('保存成功')
        this.show = false
        this.getOwnersByRoomId();
      }).finally(() => {
        this.saving = false
      })
    },

    onSelectMember(row) {
      this.selectedMember = {};
      this.selectedMember = JSON.parse(JSON.stringify(row))
      this.selectedMember.identityImage = {}
      this.show = true;
    },

    onShowBirthdayPopup() {
      // console.log('---------------------')
      if (this.selectedMember.birthday) {
        this.currentDate = new Date(moment(this.selectedMember.birthday).format('YYYY-MM-DD'));
      }
      this.birthdayPopup = true
    },
    onBirthdayConfirm(date) {
      this.selectedMember.birthday = this.formatDate(date);
      this.selectedMember.birthdayStr = this.formatDate(date);
      this.birthdayPopup = false
    },
    onBirthdayCancel() {
      this.birthdayPopup = false
    },
    formatDate(date) {
      // return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      return formatDate(date, 'yyyy-MM-dd');
    },

    onNationConfirm(value) {
      this.selectedMember.nation = value;
      this.nationPopup = false
    },

    onEducationConfirm(value) {
      this.selectedMember.education = value;
      this.educationPopup = false
    },
    onNativePlaceConfirm(data) {
      if (data.length < 2 || data[2] === undefined || data[1] === undefined) {
        return
      }
      this.selectedMember.nativeCode = data[2].code;
      this.selectedMember.nativePlace = data[0].name + ' ' + data[1].name + ' ' + data[2].name;
      this.nativePlacePopup = false
    },

    onRegisteredResidenceConfirm(data) {
      if (data.length < 2 || data[2] === undefined || data[1] === undefined) {
        return
      }
      this.selectedMember.domicilePlaceCode = data[2].code;
      this.selectedMember.domicilePlace = data[0].name + ' ' + data[1].name + ' ' + data[2].name;
      this.registeredResidencePopup = false
    },
    onGenderConfirm(value) {
      if (value === '男') {
        this.selectedMember.gender = 1;
      } else if (value === '女') {
        this.selectedMember.gender = 2;
      } else {
        this.selectedMember.gender = 0;
      }
      this.selectedMember.genderStr = value;
      this.genderPopup = false
    },
    onDownLoad() {
      let url = '';
      let timestamp = new Date().getTime();
      if (this.deliveryDataRecord && this.deliveryDataRecord.isSign) {
        url = this.alreadySignPDFUrl + this.roomId + '&time=' + timestamp.toString();
      } else {
        url = this.downloadUrl + this.roomId + '&time=' + timestamp.toString();
      }
      console.log(url)
      window.open(url, '_blank')
    },
    onOwnerInforDownLoadPdf() {
      let url = '';
      let timestamp = new Date().getTime();
      // if (this.deliveryDataRecord && this.deliveryDataRecord.isSign) {
      // url = this.alreadySignPDFUrl + this.roomId + '&time=' + timestamp.toString();
      // } else {
      url = util.ApiUrl + 'DocumentTransfer/OwnerInformationDataPdf?roomId=' + this.roomId + '&time=' + timestamp.toString();
      // }
      window.open(url, '_blank')
    },
    onCanvasClear() {
      this.$refs.SignCanvas.canvasClear();
    },
    async saveAsImg() {
      const img = this.$refs.SignCanvas.saveAsImg();

      let file = this.base64toFile(img, this.memberInfo.name + '.png')
      let data = new FormData()
      data.append("file", file)
      // data.append("associateId", this.roomId)
      data.append("associateType", 'DeliveryDataSignature')
      this.saving = true;
      abp.ajax.post('/file/upload', data, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
        const result = res.data.result;
        this.signSuccess(result);
      }).finally(() => {
        this.saving = false;
        this.showSignPopup = false;
      })
    },
    base64toFile(dataurl, filename) {
      let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type: mime});
    },
    /*签名成功*/
    signSuccess(data) {
      let page = {
        roomId: this.roomId,
        signatureImage: {
          associateId: this.roomId,
          addAttrIds: [],
          delAttrIds: [],
          associateType: 'DeliveryDataSignature',
        },
        businessType: 20
      };
      page.signatureImage.addAttrIds.push(data.id);
      signSuccess(page).then(res => {
        this.$toast('签名成功');
        this.showSignPopup = false;
        this.getDeliveryDataRecord()
      })
    },
    // getAllAssociate() {
    //   var page = {
    //     associateType: 'DeliveryDataSignature',
    //     associateId: this.roomId
    //   }
    //   getAllAssociate(page).then(res => {
    //     this.signatureImages = [];
    //     if (res.data.result) {
    //       for (let i = 0; i < res.data.result.items.length; i++) {
    //         var item = res.data.result.items[i];
    //         this.signatureImages.push(item.id)
    //       }
    //     }
    //   })
    // },
    getDeliveryDataRecord() {
      this.$store.dispatch({
        type: 'newOwner/getDeliveryDataRecord',
        data: {roomId: this.roomId, businessType: 20}
      })
    }
  },
  created() {
    this.roomId = parseInt(this.$route.params.roomId) || 0;
    if (this.roomId > 0) {
      this.getRoom()
      this.getOwnersByRoomId()
    }
    this.getMyMember()
    // this.getAllAssociate()
    this.getDeliveryDataRecord()
  }
}
